// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   SessionPage.responsive.css
   Responsive Stylesheet for Individual Clinical Session Workspace
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .mgsession-page,
  .session-page,
  .session-workspace {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .mgsession-hero {
    grid-template-columns: 1fr !important;
    gap: 22px !important;
    padding: 24px !important;
  }

  .mgsession-hero h1 {
    font-size: clamp(26px, 4vw, 34px) !important;
    line-height: 1.12 !important;
  }

  .mgsession-ai-card {
    max-width: 100% !important;
    padding: 20px !important;
  }

  /* Top Grid: Patient Details + Session Status */
  .mgsession-top-grid {
    grid-template-columns: 1fr !important;
    gap: 16px !important;
    margin: 18px 0 !important;
  }

  .mgsession-summary-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  .mgsession-status-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  /* Horizontal Scrolling Tabs on Tablet */
  .mgsession-tabs {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    gap: 8px !important;
    padding: 4px 2px 10px !important;
    -webkit-overflow-scrolling: touch !important;
    scrollbar-width: none !important;
  }

  .mgsession-tabs::-webkit-scrollbar {
    display: none !important;
  }

  .mgsession-tab {
    flex: 0 0 auto !important;
    min-width: 150px !important;
    padding: 12px 16px !important;
    border-radius: 12px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .mgsession-page,
  .session-page,
  .session-workspace {
    padding: 10px 10px 30px !important;
  }

  .mgsession-hero {
    padding: 16px 14px !important;
    gap: 16px !important;
    border-radius: 16px !important;
  }

  .mgsession-hero h1 {
    font-size: 22px !important;
    line-height: 1.15 !important;
  }

  .mgsession-hero p {
    font-size: 13px !important;
    line-height: 1.5 !important;
    margin: 10px 0 14px !important;
  }

  /* Action buttons */
  .mgsession-actions {
    display: flex !important;
    gap: 8px !important;
    flex-wrap: wrap !important;
    width: 100% !important;
  }

  .mgsession-actions .mgsession-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 6px);
    min-height: 40px !important;
    font-size: 12.5px !important;
    padding: 8px 10px !important;
  }

  .mgsession-actions .mgsession-btn:last-child {
    flex: 1 1 100% !important;
  }

  .mgsession-ai-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  /* Top Grid: Patient Details + Session Status */
  .mgsession-top-grid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
    margin: 14px 0 !important;
  }

  .mgsession-card,
  .mgsession-dark-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .mgsession-card-head h2,
  .mgsession-dark-head h2 {
    font-size: 17px !important;
  }

  .mgsession-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
  }

  .mgsession-summary-item {
    padding: 10px !important;
    border-radius: 10px !important;
  }

  .mgsession-summary-item strong {
    font-size: 14px !important;
  }

  .mgsession-status-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
  }

  .status-box,
  .mgsession-status-card {
    padding: 10px 8px !important;
    border-radius: 10px !important;
  }

  /* Horizontal Scrolling Tabs on Mobile */
  .mgsession-tabs {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    gap: 6px !important;
    padding: 2px 2px 8px !important;
    -webkit-overflow-scrolling: touch !important;
    margin: 14px 0 16px !important;
  }

  .mgsession-tab {
    flex: 0 0 auto !important;
    min-width: 130px !important;
    padding: 10px 12px !important;
    border-radius: 10px !important;
  }

  .mgsession-tab strong {
    font-size: 12.5px !important;
  }

  .mgsession-tab span {
    font-size: 10.5px !important;
  }

  /* Tab Panel Content */
  .mgsession-tab-panel {
    width: 100% !important;
  }

  /* Questionnaire adjustments on mobile */
  .questionnaire-stepper-wrap {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .stepper-header {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  .stepper-actions {
    display: flex !important;
    gap: 8px !important;
    width: 100% !important;
  }

  .stepper-actions .btn {
    flex: 1 1 !important;
    min-height: 40px !important;
  }

  /* Voice Live questionnaire */
  .voice-record-btn {
    width: 54px !important;
    height: 54px !important;
  }

  /* Doctor Review Form */
  .doctor-review-card {
    padding: 16px 14px !important;
    border-radius: 14px !important;
  }

  .doctor-review-form .form-grid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }

  /* AI Chat Drawer on Mobile */
  .session-ai-drawer {
    width: min(94vw, 420px) !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SessionPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;;;IAGE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,4CAA4C;IAC5C,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA,+CAA+C;EAC/C;IACE,qCAAqC;IACrC,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;EACtB;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;EACtB;;EAEA,wCAAwC;EACxC;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,gCAAgC;IAChC,4CAA4C;IAC5C,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;;AAEA;;+EAE+E;AAC/E;EACE;;;IAGE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA,mBAAmB;EACnB;IACE,wBAAwB;IACxB,mBAAmB;IACnB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,YAAoC;IAApC,cAAoC;IAApC,2BAAoC;IACpC,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA,+CAA+C;EAC/C;IACE,qCAAqC;IACrC,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;;IAEE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;IAC3D,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;IAC3D,mBAAmB;EACrB;;EAEA;;IAEE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA,wCAAwC;EACxC;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,+BAA+B;IAC/B,4CAA4C;IAC5C,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,sBAAsB;EACtB;IACE,sBAAsB;EACxB;;EAEA,wCAAwC;EACxC;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,oBAAkB;IAClB,2BAA2B;EAC7B;;EAEA,6BAA6B;EAC7B;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,uBAAuB;EACvB;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA,6BAA6B;EAC7B;IACE,kCAAkC;EACpC;AACF","sourcesContent":["/* ==========================================================================\n   SessionPage.responsive.css\n   Responsive Stylesheet for Individual Clinical Session Workspace\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .mgsession-page,\n  .session-page,\n  .session-workspace {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .mgsession-hero {\n    grid-template-columns: 1fr !important;\n    gap: 22px !important;\n    padding: 24px !important;\n  }\n\n  .mgsession-hero h1 {\n    font-size: clamp(26px, 4vw, 34px) !important;\n    line-height: 1.12 !important;\n  }\n\n  .mgsession-ai-card {\n    max-width: 100% !important;\n    padding: 20px !important;\n  }\n\n  /* Top Grid: Patient Details + Session Status */\n  .mgsession-top-grid {\n    grid-template-columns: 1fr !important;\n    gap: 16px !important;\n    margin: 18px 0 !important;\n  }\n\n  .mgsession-summary-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n    gap: 10px !important;\n  }\n\n  .mgsession-status-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n    gap: 10px !important;\n  }\n\n  /* Horizontal Scrolling Tabs on Tablet */\n  .mgsession-tabs {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    overflow-x: auto !important;\n    gap: 8px !important;\n    padding: 4px 2px 10px !important;\n    -webkit-overflow-scrolling: touch !important;\n    scrollbar-width: none !important;\n  }\n\n  .mgsession-tabs::-webkit-scrollbar {\n    display: none !important;\n  }\n\n  .mgsession-tab {\n    flex: 0 0 auto !important;\n    min-width: 150px !important;\n    padding: 12px 16px !important;\n    border-radius: 12px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .mgsession-page,\n  .session-page,\n  .session-workspace {\n    padding: 10px 10px 30px !important;\n  }\n\n  .mgsession-hero {\n    padding: 16px 14px !important;\n    gap: 16px !important;\n    border-radius: 16px !important;\n  }\n\n  .mgsession-hero h1 {\n    font-size: 22px !important;\n    line-height: 1.15 !important;\n  }\n\n  .mgsession-hero p {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    margin: 10px 0 14px !important;\n  }\n\n  /* Action buttons */\n  .mgsession-actions {\n    display: flex !important;\n    gap: 8px !important;\n    flex-wrap: wrap !important;\n    width: 100% !important;\n  }\n\n  .mgsession-actions .mgsession-btn {\n    flex: 1 1 calc(50% - 6px) !important;\n    min-height: 40px !important;\n    font-size: 12.5px !important;\n    padding: 8px 10px !important;\n  }\n\n  .mgsession-actions .mgsession-btn:last-child {\n    flex: 1 1 100% !important;\n  }\n\n  .mgsession-ai-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  /* Top Grid: Patient Details + Session Status */\n  .mgsession-top-grid {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n    margin: 14px 0 !important;\n  }\n\n  .mgsession-card,\n  .mgsession-dark-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgsession-card-head h2,\n  .mgsession-dark-head h2 {\n    font-size: 17px !important;\n  }\n\n  .mgsession-summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 8px !important;\n  }\n\n  .mgsession-summary-item {\n    padding: 10px !important;\n    border-radius: 10px !important;\n  }\n\n  .mgsession-summary-item strong {\n    font-size: 14px !important;\n  }\n\n  .mgsession-status-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 8px !important;\n  }\n\n  .status-box,\n  .mgsession-status-card {\n    padding: 10px 8px !important;\n    border-radius: 10px !important;\n  }\n\n  /* Horizontal Scrolling Tabs on Mobile */\n  .mgsession-tabs {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    overflow-x: auto !important;\n    gap: 6px !important;\n    padding: 2px 2px 8px !important;\n    -webkit-overflow-scrolling: touch !important;\n    margin: 14px 0 16px !important;\n  }\n\n  .mgsession-tab {\n    flex: 0 0 auto !important;\n    min-width: 130px !important;\n    padding: 10px 12px !important;\n    border-radius: 10px !important;\n  }\n\n  .mgsession-tab strong {\n    font-size: 12.5px !important;\n  }\n\n  .mgsession-tab span {\n    font-size: 10.5px !important;\n  }\n\n  /* Tab Panel Content */\n  .mgsession-tab-panel {\n    width: 100% !important;\n  }\n\n  /* Questionnaire adjustments on mobile */\n  .questionnaire-stepper-wrap {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .stepper-header {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 8px !important;\n  }\n\n  .stepper-actions {\n    display: flex !important;\n    gap: 8px !important;\n    width: 100% !important;\n  }\n\n  .stepper-actions .btn {\n    flex: 1 !important;\n    min-height: 40px !important;\n  }\n\n  /* Voice Live questionnaire */\n  .voice-record-btn {\n    width: 54px !important;\n    height: 54px !important;\n  }\n\n  /* Doctor Review Form */\n  .doctor-review-card {\n    padding: 16px 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .doctor-review-form .form-grid {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n  }\n\n  /* AI Chat Drawer on Mobile */\n  .session-ai-drawer {\n    width: min(94vw, 420px) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
